import styled, { css } from "styled-components";

export const PhobioScreen = styled.div<{
  $backgroundColor?: string;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: rgba(0, 0, 0, 0.08) 2px 4px 12px 0px;
  border-radius: 16px;
  ${({ $backgroundColor }) => $backgroundColor
  && css`
      background-color: ${$backgroundColor};
    `}
`;
